import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from './Navbar'; // Import the Navbar component
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container, // Import Container for centering
} from '@mui/material';

const Portal = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch reports from the backend
  useEffect(() => {
    const fetchReports = async () => {
      try {
        console.log('Fetching reports...');
        const response = await axios.get('https://femizero.samzdixon.tech/api/reports');
        console.log('Response:', response.data);
        setReports(response.data);
      } catch (error) {
        console.error('Error fetching reports:', error);
        alert('Failed to fetch reports. Please try again later.');
      } finally {
        setLoading(false); // Stop loading whether the request succeeds or fails
      }
    };

    fetchReports();
  }, []);

  return (
    <>
      {/* Include the Navbar component */}
      <Navbar />

      {/* Main content */}
      <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          Incident Reports
        </Typography>
        {loading ? ( // Show loading state
          <Typography variant="body1" sx={{ mt: 2 }}>
            Loading reports...
          </Typography>
        ) : reports.length > 0 ? ( // Show data if available
          <TableContainer component={Paper} sx={{ width: '100%', maxWidth: '800px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Incident Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Time</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Anonymous</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reports.map((report) => (
                  <TableRow key={report._id}>
                    <TableCell>{report.incidentType}</TableCell>
                    <TableCell>{report.date}</TableCell>
                    <TableCell>{report.time}</TableCell>
                    <TableCell>{report.location}</TableCell>
                    <TableCell>{report.description}</TableCell>
                    <TableCell>{report.isAnonymous ? 'Yes' : 'No'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : ( // Show message if no reports are found
          <Typography variant="body1" sx={{ mt: 2 }}>
            No reports found.
          </Typography>
        )}
      </Container>
    </>
  );
};

export default Portal;